module.exports = __webpack_public_path__ + "img/OverseaMember32.bdb4979c.jpg";